import React, { useState, useEffect } from "react";
import StaffTable from "../../components/StaffTable";
import AddStaffModal from "../../components/AddStaffModal";
import BulkAddStaffModal from "../../components/BulkAddStaffModal";
import Sidebar from "../../components/MasterSideBar";
import Topbar from "../../components/TopbarNav";
import { useNavigate } from "react-router-dom";
import { getStaff } from "../../api/staff-calls-api";

export default function StaffProfilePage() {
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [showBulkForm, setShowBulkForm] = useState(false);
  const navigate = useNavigate();



  const fetchUsers = async () => {
    try {
      setLoading(true);
      setError(null);
      const { list } = await getStaff();
      setUsers(Array.isArray(list) ? list : []);
      setSuccessMsg("Staff loaded successfully");
    } catch (err) {
      setError(err.message || "Failed to fetch staff.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    let successTimer;
    if (successMsg) {
      successTimer = setTimeout(() => setSuccessMsg(""), 3000);
    }
    return () => clearTimeout(successTimer);
  }, [successMsg]);

  useEffect(() => {
    let errorTimer;
    if (error) {
      errorTimer = setTimeout(() => setError(null), 3000);
    }
    return () => clearTimeout(errorTimer);
  }, [error]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  return (
    <div className="flex min-h-screen bg-gray-50 relative">
      {/* Sidebar */}
      <Sidebar onLogout={handleLogout} />

      {/* Main Content */}
      <div className="flex-1 md:pl-64">
        <Topbar />

        {/* Popup Notifications */}
        {successMsg && (
          <div className="fixed top-5 left-1/2 transform -translate-x-1/2 z-50">
            <div className="bg-green-500 text-white px-6 py-3 rounded shadow-lg animate-fade-in-out">
              ✅ {successMsg}
            </div>
          </div>
        )}
        {error && (
          <div className="fixed top-5 left-1/2 transform -translate-x-1/2 z-50">
            <div className="bg-red-500 text-white px-6 py-3 rounded shadow-lg animate-fade-in-out">
              ❌ {error}
            </div>
          </div>
        )}

        <main className="pt-20 md:pt-24 px-3 sm:px-6 lg:px-8 pb-8 overflow-y-auto max-h-screen">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-3">
            <h2 className="text-base sm:text-xl font-bold text-gray-700">STAFF PROFILES TABLE</h2>
            <div className="flex flex-wrap gap-2">
              <button
                onClick={() => setShowForm(true)}
                className="bg-orange-500 text-white px-3 sm:px-4 py-2 rounded text-sm sm:text-base hover:bg-orange-600 w-full sm:w-auto"
              >
                Add New Staff
              </button>
              {/* Bulk Upload Button */}
              <button
                onClick={() => setShowBulkForm(true)}
                className="bg-orange-500 text-white px-3 sm:px-4 py-2 rounded text-sm sm:text-base hover:bg-orange-600 w-full sm:w-auto"
              >
                Bulk Upload Staff
              </button>
            </div>
          </div>

          {/* Staff Table or Loading */}
          <div className="overflow-x-auto bg-white shadow rounded">
            {loading ? (
              <div className="text-center text-gray-500">Loading staff...</div>
            ) : (
              <StaffTable staff={users} onStaffUpdated={fetchUsers} />
            )}
          </div>

          {/* Add Staff Modal */}
          {showForm && (
            <AddStaffModal
              closeForm={() => setShowForm(false)}
              onUserAdded={() => {
                fetchUsers();
                setShowForm(false);
              }}
            />
          )}



          {/* Bulk Add Staff Modal */}
          {showBulkForm && (
            <BulkAddStaffModal
              closeForm={() => setShowBulkForm(false)}
              onUsersAdded={fetchUsers} // Pass the same handler to reload the list
            />
          )}

          {/* Dashboard Widgets
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
            <div className="bg-white shadow rounded p-4 overflow-x-auto">
              <h3 className="text-lg font-semibold text-orange-600 mb-4">Leave Summary</h3>
              <table className="w-full text-sm min-w-[600px]">
                <thead>
                  <tr className="text-left text-gray-600">
                    <th className="p-2">Employee</th>
                    <th className="p-2">Days Allocated</th>
                    <th className="p-2">Used Leave</th>
                    <th className="p-2">Return Date</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { name: "Kathryn Murphy", days: 40, used: 30, returnDate: "25-05-25" },
                    { name: "Bridget Akol", days: 50, used: 40, returnDate: "12-05-25" },
                    { name: "Timothy Christian", days: 30, used: 25, returnDate: "09-07-25" },
                  ].map((emp, i) => (
                    <tr key={i}>
                      <td className="p-2 whitespace-nowrap">{emp.name}</td>
                      <td className="p-2 whitespace-nowrap">{emp.days}</td>
                      <td className="p-2 whitespace-nowrap">
                        <div className="w-full bg-gray-200 rounded-full h-2">
                          <div
                            className="bg-orange-500 h-2 rounded-full"
                            style={{ width: `${(emp.used / emp.days) * 100}%` }}
                          />
                        </div>
                      </td>
                      <td className="p-2 whitespace-nowrap">{emp.returnDate}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="bg-white shadow rounded p-4">
              <h3 className="text-lg font-semibold text-orange-600 mb-4">Attendance Pattern</h3>
              <img
                src="/graph-placeholder.png"
                alt="Attendance graph"
                className="w-full h-40 object-contain"
              />
            </div>
          </div> */}
        </main>
      </div>
    </div>
  );
}
